module.exports = __webpack_public_path__ + "img/pic_two.91b3df43.png";